import { useLocation, useNavigate } from 'react-router-dom';
import qs from 'qs';
import { SortDirectionEnum } from '../services/Schemas/ListQueryString';

export interface Sorts {
  [key: string]: {
    column: string;
    direction: SortDirectionEnum;
  };
}

export interface ApplyUrlSortsFunction {
  (newSorts: Sorts): void;
}

function useUrlSort() {
  const navigate = useNavigate();
  const location = useLocation();

  const parseUrlSorts = () => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true, depth: 3 }) as Record<string, any>;
    return queryParams.sorts || {};
  };


  const applyUrlSorts: ApplyUrlSortsFunction = (newSorts) => {
    const currentQuery = qs.parse(location.search, { ignoreQueryPrefix: true }) as Record<string, any>;
    const { sorts, ...remainingQuery } = currentQuery;

    const updatedQuery = {
      ...remainingQuery,
      sorts: newSorts,
    };
    const queryString = qs.stringify(updatedQuery, { encode: true });
    navigate({
      pathname: location.pathname,
      search: `?${queryString}`,
    });
  };

  const getSortValue = (column: string): { direction: SortDirectionEnum } | undefined => {
    const sorts = parseUrlSorts();
    return sorts[column];
  };

  return {
    applyUrlSorts,
    parseUrlSorts,
    getSortValue,
  };
}

export default useUrlSort;
